export const FULL_SCREEN_ACTION_KEY = 'fullScreen'

export const REMOVE_DRAFT_ACTION_KEY = 'removeDraft'

export const REMOVE_DRAFT_DIVIDER_ACTION_KEY = 'removeDraftDivider'
